export const deriveRatingWidth = (rating, fallbackWidth = '0%') => {
  if (rating === '' || rating == null || Number.isNaN(Number(rating))) {
    return fallbackWidth;
  }
  const numeric = Math.min(5, Math.max(0, Number(rating)));
  return `${Math.round((numeric / 5) * 100)}%`;
};
